import React, { memo, useState } from 'react';

const getDivisionIds = (division) =>
  division.divisions && division.divisions.length > 0
    ? division.divisions.map((d) => d.id)
    : [division.id];

const DivisionGroups = ({ division, handleChange }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);

  const handleCollapseClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    setIsCollapsed((collapsed) => !collapsed);
  };

  const handleNameClick = (item) => handleChange(getDivisionIds(item));

  return (
    <div className="divisions-dropdown">
      <div
        className="divisions-collapse"
        onClick={() => handleNameClick(division)}
        role="button"
        tabIndex={0}
      >
        {division.divisions && division.divisions.length > 0 && (
          <div
            className="divisions-collapse__icon"
            onClick={handleCollapseClick}
            role="button"
            tabIndex={0}
          >
            <i
              className={`fa ${isCollapsed ? 'fa-angle-right' : 'fa-angle-down'}`}
            />
          </div>
        )}
        {division?.name}
      </div>
      {!isCollapsed &&
        (division.divisions || []).map((d) => (
          <div
            key={`${division.id}-${d.id}`}
            onClick={() => handleNameClick(d)}
            className="divisions-collapse divisions-dropdown__group-children"
            role="button"
            tabIndex={0}
          >
            {d.name}
          </div>
        ))}
    </div>
  );
};

export default memo(DivisionGroups);
